import { formatDate, Location } from '@angular/common';
import { ChangeDetectorRef, Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Subscription } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { LayoutService, ScreenSize } from 'libs/portal/src/layout/layout.service';
import { DetailDeviceHeader } from 'libs/portal/src/models/Device';
import { DeviceLocation } from 'libs/portal/src/models/DeviceLocation';
import { DevicePreset } from 'libs/portal/src/models/DevicePreset';
import { GetDeviceLocationRequest } from 'libs/portal/src/models/GetDeviceLocationRequest';
import { GetDeviceRequest } from 'libs/portal/src/models/GetDeviceRequest';
import { MapConfig } from 'libs/portal/src/models/MapConfig';
import { MinDeviceDetails } from 'libs/portal/src/models/MinDeviceDetails';
import { Sim } from 'libs/portal/src/models/Sim';
import { LocationRadiusModalComponent } from 'libs/portal/src/modules/keepalive/components/location-radius-modal/location-radius-modal/location-radius-modal.component';
import { GenericService } from 'libs/portal/src/services/generic/generic.service';
import { MemoryService } from 'libs/portal/src/services/memory/memory.service';
import { TitleService } from 'libs/portal/src/services/title/title.service';
import { ToastrService } from 'ngx-toastr';
import { ToolsService } from 'libs/portal/src/services/tools/tools.service';
import { UserAccessRole, UserRightsService } from 'libs/portal/src/services/user-rights/user-rights.service';
import { Endpoints } from '@huge-monorepo/portal/config';
import { ChartOptions } from '../device-bundle-used-chart/device-bundle-used-chart.component';
import { DeviceMapComponent } from '../device-map/device-map.component';
import { GraphChange } from 'libs/portal/src/models/GraphChange';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmReasonModalComponent } from '../confrim-reason-modal/confirm-reason-modal.component';
import { SharedToolsService } from '@huge-monorepo/shared/tools';
import { BaseMapLocation } from 'libs/shared/src/interfaces/BaseMapLocation';
import { DeviceLocationTableData } from 'libs/shared/src/interfaces/DeviceLocationTableData';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MapBounds } from 'libs/shared/src/interfaces/MapBounds';
import { CardTableHeader } from '../card-table/models/card-table-header.model';
import { CardTableOptions } from '../card-table/models';
import { DateAdapter, MAT_DATE_FORMATS } from '@angular/material/core';
import { CustomDateAdapter, CUSTOM_DATE_FORMATS } from 'libs/portal/src/modules/tools/card-table/components/custom-date-adapter';

@Component({
  selector: 'app-device-details',
  templateUrl: './device-details.component.html',
  styleUrls: ['./device-details.component.scss'],
  providers: [
    { provide: DateAdapter, useClass: CustomDateAdapter },
    { provide: MAT_DATE_FORMATS, useValue: CUSTOM_DATE_FORMATS },
  ],
})
export class DeviceDetailsComponent implements OnInit, OnDestroy {
  @ViewChild('deviceMap', { static: false }) public deviceMap: DeviceMapComponent;
  private kaTypes: string[] = [];
  mapConfig: MapConfig;
  page = 1;
  mapSize = 6;
  requestParameters: GetDeviceRequest = new GetDeviceRequest({});
  selectedSim: BaseMapLocation | null = null;
  // currentRingFenceValue: number = 0;
  showChatModal = false;
  ScreenSize = ScreenSize;
  loading = false;
  deviceDetailsConfig: MinDeviceDetails;
  loadingRingfenceData = false;
  ringFenceData: any[] | null = [];
  deviceLocations: DeviceLocation[];
  memorySub: Subscription;

  isCDR = false;
  isKA = false;
  isMikrotik = false;

  selectedPreset: DevicePreset;
  presetToPreview: string | null;
  presetResult: string | null;
  dateMonthString = formatDate(Date.now(), '(yyyy-MM)', 'en');

  LocationHistoryBody: GetDeviceLocationRequest = new GetDeviceLocationRequest();

  detailsNavOptions: Object[];
  presets: DevicePreset[];
  presetLoading = false;
  pageChangeVal: Object;
  endpointsLoading = 0;

  // kaDeviceDetails = null;
  // cdrDeviceDetails = null;
  detailsObject: any = null;
  detailHeader: DetailDeviceHeader | null;
  deviceBundleUsed = null;
  firstLoad = true;
  ringfencesLoading = false;
  deviceStatusOverTime = null;
  sims: Sim[];

  totalRingfences: number;
  loadingRingfences = false;
  RingfenceLoadingError = false;
  orderRingfencesBy = 'Timestamp';
  RingfencesTableCount = 10;
  RingfencesSearch = '';
  RingfencesTableOffset = 0;
  currentRingfencesPage = 1;
  RingfencesDesc = true;
  detailsCardWidth = '100%';
  mapDivWidth = '75%';

  usageOverMonthsData: any[] | null;
  isMikrotikAdmin = false;
  obfuscateData = false;
  authSubscription: Subscription;

  AccessObject: UserAccessRole | null;
  userHasWriteAccess = false;

  refreshMapOnLoad = false;
  mapCanLoad = false;
  apnLoading = false;

  daysInMonth: number;
  usageOverMonthsStorage: any[] = [];
  willExceedBundle = false;
  unit = 'MB';

  customLegendItems = ['Over Bundle', 'Under Bundle', 'Expected to Exceed Bundle'];
  customLegendColors = ['#C93F55', '#3FC944', '#FFBE65'];

  VodacomAPNChartOptions: Partial<ChartOptions> | null;
  MTNAPNChartOptions: Partial<ChartOptions> | null;
  TelkomAPNChartOptions: Partial<ChartOptions> | null;

  deviceIPs: string[] = [];
  deviceApnList: any[] = [];
  mnoMep: Map<string, Map<string, any>> = new Map();
  mnoAPNs: any[] = [];
  selectedRelayMNO: string = 'All';
  selectedRelayIP: string | null;
  relaySixMonthObj: any;
  relayDailyData: Array<any> | null = [];
  DailyRelayGraphConfig: GraphChange | any = {
    Callback: null,
    Transformer: this.dailyRelayDataFormatter,
    StartDate: this.tools.GetStartOfMonth(new Date()).toISOString(),
    EndDate: this.tools.GetEndOfMonth().toISOString(),
    Timeperiod: null,
    Interval: 1,
    TimeFrame: null,
    Data: {
      GraphTitle: 'Transactions (' + this.tools.GetStartOfMonth(new Date()).toLocaleDateString('sv-SE') + ' - ' + new Date().toLocaleDateString('sv-SE') + ')',
      GraphType: 'stacked-bar',
      SeriesData: [],
      XAxisLabel: 'Time',
      YAxisLabel: '',
      XAxisCategories: [],
    },
    UnprocessedData: null,
    GraphHandler: null,
    GraphDashboard: this,
    GraphQueryParams: null,
    IsReady: false,
    tools: this.tools,
  };

  relayMonthlyData = null;
  relayMonthlyBarData: any = [];
  MonthlyRelayGraphConfig: GraphChange | any = {
    Callback: null,
    Transformer: this.monthlyRelayDataFormatter,
    StartDate: this.tools.GetStartOfMonth(new Date()).toISOString(),
    EndDate: this.tools.GetEndOfMonth().toISOString(),
    Timeperiod: null,
    Interval: 1,
    TimeFrame: null,
    Data: {
      GraphTitle: 'Total Transactions past 6 months',
      GraphType: 'stacked-bar',
      SeriesData: [],
      XAxisLabel: 'Time',
      YAxisLabel: '',
      XAxisCategories: [],
    },
    UnprocessedData: null,
    GraphHandler: null,
    GraphDashboard: this,
    GraphQueryParams: null,
    IsReady: false,
    tools: this.tools,
  };
  monthDiff: number = 5;

  DailyDataUsageGraphConfig: GraphChange = {
    Callback: null,
    Transformer: (c: GraphChange) => { },
    StartDate: this.tools.GetStartOfMonth(new Date()).toISOString(),
    EndDate: this.tools.GetEndOfMonth().toISOString(),
    Timeperiod: null,
    Interval: 1,
    TimeFrame: null,
    Data: {
      GraphTitle: 'Bundle used in GB',
      GraphType: 'line',
      SeriesData: [],
      XAxisLabel: 'Time',
      YAxisLabel: '',
      XAxisCategories: [],
    },
    UnprocessedData: null,
    GraphHandler: null,
    GraphDashboard: this,
    GraphQueryParams: null,
    IsReady: false,
    tools: this.tools,
  };

  MonthlyDataUsageGraphConfig: GraphChange = {
    Callback: null,
    Transformer: (c: GraphChange) => { },
    StartDate: this.tools.GetStartOfMonth(new Date()).toISOString(),
    EndDate: this.tools.GetEndOfMonth().toISOString(),
    Timeperiod: null,
    Interval: 1,
    TimeFrame: null,
    Data: {
      GraphTitle: 'Data usage over 6 months',
      GraphType: 'bar',
      SeriesData: [],
      XAxisLabel: 'Time',
      YAxisLabel: '',
      XAxisCategories: [],
    },
    UnprocessedData: null,
    GraphHandler: null,
    GraphDashboard: this,
    GraphQueryParams: null,
    IsReady: false,
    tools: this.tools,
  };

  // Vodacom APN Usage
  VodacomConfig: GraphChange = {
    Callback: null,
    Transformer: (c: GraphChange) => { },
    StartDate: this.tools.GetStartOfMonth(new Date()).toISOString(),
    EndDate: this.tools.GetStartOfMonth(new Date()).toISOString(),
    Timeperiod: null,
    TimeFrame: null,
    Interval: 1,
    Data: {
      GraphTitle: 'Vodacom Data Usage per APN',
      GraphType: 'stacked-bar',
      SeriesData: [],
      XAxisLabel: 'APN',
      YAxisLabel: 'Data (in MB)',
      XAxisCategories: [],
    },
    UnprocessedData: null,
    GraphHandler: null,
    GraphDashboard: this,
    GraphQueryParams: {
      count: 100,
      offset: 0,
      search: '',
      orderBy: 'Timestamp',
      desc: false,
    },
    IsReady: false,
  };

  // MTN APN Usage
  MTNConfig: GraphChange = {
    Callback: null,
    Transformer: (c: GraphChange) => { },
    StartDate: this.tools.GetStartOfMonth(new Date()).toISOString(),
    EndDate: this.tools.GetStartOfMonth(new Date()).toISOString(),
    Timeperiod: null,
    TimeFrame: null,
    Interval: 1,
    Data: {
      GraphTitle: 'MTN Data Usage per APN',
      GraphType: 'stacked-bar',
      SeriesData: [],
      XAxisLabel: 'APN',
      YAxisLabel: 'Data (in MB)',
      XAxisCategories: [],
    },
    UnprocessedData: null,
    GraphHandler: null,
    GraphDashboard: this,
    GraphQueryParams: {
      count: 100,
      offset: 0,
      search: '',
      orderBy: 'Timestamp',
      desc: false,
    },
    IsReady: false,
  };

  // Telkom APN Usage
  TelkomConfig: GraphChange = {
    Callback: null,
    Transformer: (c: GraphChange) => { },
    StartDate: this.tools.GetStartOfMonth(new Date()).toISOString(),
    EndDate: this.tools.GetStartOfMonth(new Date()).toISOString(),
    Timeperiod: null,
    TimeFrame: null,
    Interval: 1,
    Data: {
      GraphTitle: 'Telkom Data Usage per APN',
      GraphType: 'stacked-bar',
      SeriesData: [],
      XAxisLabel: 'APN',
      YAxisLabel: 'Data (in MB)',
      XAxisCategories: [],
    },
    UnprocessedData: null,
    GraphHandler: null,
    GraphDashboard: this,
    GraphQueryParams: {
      count: 100,
      offset: 0,
      search: '',
      orderBy: 'Timestamp',
      desc: false,
    },
    IsReady: false,
  };
  APNGraphsLoading: boolean = true;

  simIDs: number[] = [];
  simLocations: BaseMapLocation[] = [];
  deviceMapBounds: MapBounds = {
    SW: {
      Lat: -36.78053281978333,
      Long: 13.479175468749984,
    },
    NE: {
      Lat: -21.868960980132858,
      Long: 35.144214531249986,
    },
  };
  invalidSimLocationCount: number = 0;
  deviceMapFormGroup = new FormGroup({
    simHops: new FormControl(10, [Validators.required, Validators.min(1)]),
  });
  deviceLocationTableOptions: CardTableOptions = {
    textSize: 'regular',
    isSelectable: false,
    flexCardLayout: false,
    propertyRowExclusions: ['SimNum', 'SimCell', 'Provider', 'TimeFrom', 'TimeTo'],
    stylePropertyPrefix: 'locations',
    clickableFlexCard: false,
  };
  deviceLocationsTableHeaders: CardTableHeader[] = [
    { Text: 'Timestamp', Width: 15, Align: 'left' },  // was 12
    { Text: 'LAC', Width: 10, Align: 'left' },         // was 4
    { Text: 'Cell ID', Width: 13, Align: 'left' },    // was 6
    { Text: 'MCC', Width: 10, Align: 'left' },         // was 4
    { Text: 'MNC', Width: 10, Align: 'left' },         // was 4
    // { Text: 'Country', Width: 12, Align: 'left' },    // was 7
    { Text: 'Latitude', Width: 21, Align: 'left' },   // was 10
    { Text: 'Longitude', Width: 21, Align: 'left' },  // was 10
    { Text: '', Width: 0 },
  ];
  // This will be an array that holds arrays (matrix) of information to populate tables of information
  deviceLocationsTableData: DeviceLocationTableData[][] = [];
  // Used in the ngStyle to get the correct amount of colums for the sims
  deviceSimTableStyle: string;

  deviceLocationsLoading: boolean = false;

  // This will be an array that holds arrays (matrix) of information to populate tables of information
  paginatedLocationsTableData: { page: number; totalLength: number; simNum: string; data: DeviceLocationTableData[] }[] = [];

  simLocationsLoading: boolean = false;

  today = new Date();
  startDateTime: string = '';
  endDateTime: string = '';
  initialStartDate: Date = new Date();
  initialEndDate: Date = new Date();
  startDateControl = new FormControl(new Date(), Validators.required);
  endDateControl = new FormControl(new Date(), Validators.required);
  todayT = '';

  cdrTableOffset = 0;
  cdrTableCount = 10;
  // private kaTypes: string[] = [];

  constructor(
    public layoutService: LayoutService,
    private genericService: GenericService,
    private titleService: TitleService,
    private endpoints: Endpoints,
    private tools: ToolsService,
    private _location: Location,
    private toastService: ToastrService,
    private auth: UserRightsService,
    private memoryService: MemoryService,
    private dialog: MatDialog,
    private sharedTools: SharedToolsService,
    private changeDetectorRef: ChangeDetectorRef,
  ) { }

  closeChatModal() {
    this.showChatModal = false;
  }

  showChat() {
    if (this.layoutService.screenSize > this.ScreenSize.MOBILE_L) {
      this.showChatModal = true;
    } else {
      // Todo check this route navigation
      // this.router.navigate([`/Chat/${this.requestParameters["KaID"]}?cdr=` + (this.isCDR == true ? "true" : "false")]);
    }
  }

  goBack() {
    this._location.back();
  }

  ngOnDestroy() {
    sessionStorage.setItem('details', JSON.stringify(this.requestParameters));
    this.authSubscription.unsubscribe();
    this.memorySub.unsubscribe();
  }

  ngOnInit() {
    this.userHasWriteAccess = this.auth.GetUserPortalReadWrite().PortalWriteAccess;
    this.kaTypes = this.auth.GetKeepAliveTypes();
    this.authSubscription = this.auth.GetUser().subscribe((user) => {
      this.obfuscateData = user.isObfuscated;
      if (!this.firstLoad) {
        location.reload();
      }
    });
    this.initUnitChangeHandler();
    this.AccessObject = this.auth.GetUserAccessRoles();
    if (!this.AccessObject) {
      this.goBack();
    }

    this.isMikrotikAdmin = this.AccessObject?.IsSuperUser() || this.AccessObject?.IsMikrotikAdmin() ? true : false;

    this.getDevicePresets();
    window.onbeforeunload = () => this.ngOnDestroy();
    this.titleService.pageTitle = 'Device details';
    if (history.state.data != null) {
      this.requestParameters = history.state.data;
      if (history.state.data.refresh != null && history.state.data.refresh) {
        this.refreshMapOnLoad = true;
      }
    } else {
      this.requestParameters = new GetDeviceRequest(JSON.parse(sessionStorage.getItem('details')));
    }
    sessionStorage.removeItem('details');

    if (this.requestParameters != null && (this.requestParameters['KaID'] > 0 || this.requestParameters['CdrID'] > 0)) {
      this.isCDR = this.requestParameters.CdrID && this.requestParameters.CdrID > 0 ? true : false;
      this.isKA = this.requestParameters.KaID && this.requestParameters.KaID > 0 ? true : false;

      // valid device ids specified
      this.endpointsLoading++;
      this.getDeviceDetails();

      if (this.requestParameters['CdrID'] && this.requestParameters['CdrID'] > 0) {
        this.getDeviceUsageOvertimeMonths(this.requestParameters['CdrID'], 5);
        this.getRouterSnapshotDetails(this.requestParameters['CdrID']);
        this.getAPNDeviceUsages(this.requestParameters['CdrID']);
      }

      if (this.requestParameters['KaID'] && this.requestParameters['KaID'] > 0) {
        this.getRingFenceData(this.requestParameters['KaID']);
        this.getLatestRingfenceAlert(this.requestParameters['KaID']);
        this.LocationHistoryBody.Count = 5;
        this.endpointsLoading++;
        this.getKADeviceLocationHistory();
      }

      this.getDeviceStatusOverTimeData(this.requestParameters['CdrID'], this.requestParameters['KaID']);
    } else {
      // No valid device specified
      // remove current route from history stack
      this.goBack();
    }

    this.initialStartDate = this.tools.GetStartOfMonth(new Date());
    this.startDateTime = this.tools.FormatStartDate(this.initialStartDate.toISOString());
    this.endDateTime = this.tools.FormatEndDate(this.endDateControl.value.toISOString());
    this.startDateControl.setValue(this.initialStartDate);

    this.startDateControl.valueChanges.subscribe((value: any) => {
      if (value == null) {
        this.startDateControl.setValue(null, { emitEvent: false });
        this.startDateTime = '';
        return;
      }
      this.startDateTime = this.tools.FormatStartDate(value.toString());
    });

    this.endDateControl.valueChanges.subscribe((value: any) => {
      if (value == null) {
        this.endDateControl.setValue(null, { emitEvent: false });
        this.endDateTime = '';
        return;
      }
      this.endDateTime = this.tools.FormatEndDate(value.toString());
      this.getSimLocationHistory();
    });
    let date = this.tools.GetStartOfMonth(new Date());
    date.setMinutes(date.getMinutes() - date.getTimezoneOffset());
    this.todayT = this.tools.GetEndOfDay(new Date()).toISOString();

    this.firstLoad = false;

    if (this.refreshMapOnLoad) {
      this.mapRefresher();
    } else {
      this.mapCanLoad = true;
    }
  }

  isValid(): Boolean {
    return this.startDateControl.valid && this.endDateControl.valid;
  }

  initUnitChangeHandler(): void {
    this.unit = this.memoryService.getLocalPreferences().getValue().preferedGraphUnit;
    this.memorySub = this.memoryService.getLocalPreferences().subscribe((prefs) => {
      if (this.unit != prefs.preferedGraphUnit) {
        this.unit = prefs.preferedGraphUnit;
        if (this.requestParameters['CdrID'] && this.requestParameters['CdrID'] > 0) {
          this.getAPNDeviceUsages(this.requestParameters['CdrID']);
        }
      }
    });
  }

  getAPNDeviceUsages(deviceID: number, start?: string, end?: string): void {
    const reqObj = {
      //Add these in to specify a specific date range. Defaults to this month
      Start: start,
      End: end,
      DeviceIds: [deviceID],
    };
    this.genericService.POST(this.endpoints.GET_DEVICE_USAGE_BY_APN, reqObj).subscribe((res: any) => {
      const mtn: any = [];
      const vodacom: any = [];
      const telkom: any = [];
      if (res.body != null) {
        let data = res.body as any[];
        data.map((item) => {
          item.Usage = this.tools.ConvertDataFromBytes(item.Usage, 'MB');
          if (item.SPDescription == 'MTN') {
            mtn.push(item);
          } else if (item.SPDescription == 'Vodacom SA') {
            vodacom.push(item);
          } else if (item.SPDescription == 'Telkom') {
            telkom.push(item);
          }
        });
        if (vodacom?.length > 0) {
          let seriesData: any = [];
          seriesData.push({
            name: 'Data Used (MB)',
            data: vodacom.map((apn, i) => {
              return {
                x: apn.APNDescription,
                y: (apn.TotalUsage / 1000 / 1000).toFixed(2),
                fillColor: '#3FC944',
              };
            }),
          });
          this.VodacomConfig.UnprocessedData = vodacom;
          this.VodacomConfig.Data.SeriesData = seriesData;
          if (seriesData?.length > 0) {
            setTimeout(() => {
              if (this.VodacomConfig.GraphHandler) {
                this.VodacomConfig.GraphHandler.transformAndPopulate(this.VodacomConfig);
              }
              this.changeDetectorRef.detectChanges();
            });
          }
        } else {
          this.VodacomConfig.UnprocessedData = vodacom;
          this.VodacomConfig.Data.SeriesData = [];
        }
        if (mtn?.length > 0) {
          let seriesData: any = [];
          seriesData.push({
            name: 'Data Used (MB)',
            data: mtn.map((apn, i) => {
              return {
                x: apn.APNDescription,
                y: (apn.TotalUsage / 1000 / 1000).toFixed(2),
                fillColor: '#3FC944',
              };
            }),
          });
          this.MTNConfig.UnprocessedData = mtn;
          this.MTNConfig.Data.SeriesData = seriesData;
          if (seriesData?.length > 0) {
            setTimeout(() => {
              if (this.MTNConfig.GraphHandler) {
                this.MTNConfig.GraphHandler.transformAndPopulate(this.MTNConfig);
              }
              this.changeDetectorRef.detectChanges();
            });
          }
        } else {
          this.MTNConfig.UnprocessedData = vodacom;
          this.MTNConfig.Data.SeriesData = [];
        }
        if (telkom?.length > 0) {
          let seriesData: any = [];
          seriesData.push({
            name: 'Data Used (MB)',
            data: telkom.map((apn) => {
              return {
                x: apn.APNDescription,
                y: (apn.TotalUsage / 1000 / 1000).toFixed(2),
                fillColor: '#3FC944',
              };
            }),
          });
          this.TelkomConfig.UnprocessedData = telkom;
          this.TelkomConfig.Data.SeriesData = seriesData;
          if (seriesData?.length > 0) {
            setTimeout(() => {
              if (this.TelkomConfig.GraphHandler) {
                this.TelkomConfig.GraphHandler.transformAndPopulate(this.TelkomConfig);
              }
              this.changeDetectorRef.detectChanges();
            });
          }
        } else {
          this.TelkomConfig.UnprocessedData = vodacom;
          this.TelkomConfig.Data.SeriesData = [];
        }

        this.APNGraphsLoading = false;
      }
    });
  }

  mapRefresher() {
    setTimeout(() => {
      if (this.endpointsLoading <= 0) {
        setTimeout(() => {
          this.mapCanLoad = true;
        });
      } else {
        this.mapRefresher();
      }
    }, 500);
  }

  buildSidePane() {
    const navOptions = [
      {
        Text: 'Details',
        Links: [
          {
            Text: 'General',
            ID: 1,
            Active: true,
          },
          {
            Text: 'Details',
            ID: 5,
            Active: false,
          },
        ],
      },
    ];

    if (this.isCDR) {
      if (this.isMikrotik && this.AccessObject?.IsMikrotikGraphing()) {
        navOptions[0]['Links'].push(
          {
            Text: 'Availability Graph',
            ID: 7,
            Active: false,
          },
          {
            Text: 'Jitter Graph',
            ID: 8,
            Active: false,
          },
          {
            Text: 'Latency Graph',
            ID: 9,
            Active: false,
          },
        );
      }

      if (this.isMikrotik && (this.AccessObject?.IsMikrotikUser() || this.AccessObject?.IsSuperUser())) {
        navOptions[0]['Links'].push({
          Text: 'Device Presets',
          ID: 10,
          Active: false,
        });
      }

      if (this.detailsObject?.CdrDevice?.SIMs?.length && (this.AccessObject?.IsCDRUser() || this.AccessObject?.IsSuperUser())) {
        navOptions[0].Links.push({
          Text: 'Usage Chart',
          ID: 3,
          Active: false,
        });
        navOptions[0].Links.push({
          Text: 'Map',
          ID: 15,
          Active: false,
        });
      }
    }

    if (this.isKA && (this.AccessObject?.IsKeepAliveUser() || this.AccessObject?.IsSuperUser()) && this.detailHeader.TLSEnabled == false) {
      navOptions[0]['Links'].push({
        Text: 'Ringfence Logs',
        ID: 6,
        Active: false,
      });
    }

    if (
      ((this.isKA && (this.AccessObject?.IsKeepAliveUser() || this.AccessObject?.IsSuperUser())) ||
        (this.isMikrotik && (this.AccessObject?.IsMikrotikUser() || this.AccessObject?.IsSuperUser()))) &&
      this.detailHeader.TLSEnabled == false
    ) {
      navOptions[0]['Links'].push({
        Text: 'Device Map',
        ID: 2,
        Active: false,
      });
    }

    navOptions[0]['Links'].push({
      Text: 'Activity Chart',
      ID: 4,
      Active: false,
    });

    if (this.auth.HasRelayAccess() && this.AccessObject.HasRelayAccess()) {
      // TODO: should be checking group accesses
      navOptions[0]['Links'].push({
        Text: 'Relay',
        ID: 11,
        Active: false,
      });
    }

    navOptions[0].Links.sort((a, b) => {
      if (b.ID == 1 || b.ID == 5) {
        return 0;
      }

      return ('' + a.Text).localeCompare(b.Text);
    });

    this.detailsNavOptions = navOptions;
  }

  getRingFenceData(id: number) {
    if (!this.AccessObject?.IsKeepAliveUser() && !this.AccessObject?.IsSuperUser()) {
      return;
    }
    this.ringFenceData = null;
    this.loadingRingfenceData = true;
    this.genericService.GET(this.endpoints.GET_DEVICE_RING_FENCE_LOGS(id)).subscribe(
      (result: any) => {
        this.ringFenceData = result['body'];
        this.loadingRingfenceData = false;
      },
      () => {
        this.loadingRingfenceData = false;
      },
    );
  }

  getDeviceStatusOverTimeData(cdrID: number | null, kaID: number | null) {
    const obj = {
      Start: this.tools.FormatStartDate(this.tools.GetStartOfMonth(new Date()).toISOString()),
      End: this.tools.FormatEndDate(this.tools.GetEndOfMonth().toISOString()),
      DeviceID: cdrID,
      KADeviceID: kaID,
      Interval: 1,
      CDR: true,
      KeepAlive: true,
      Mikrotik: true,
      AllDevices: false,
    };

    this.genericService.POST(this.endpoints.GET_DEVICE_STATUS_OVER_TIME, obj).subscribe((data) => {
      if (data['body'] != null) {
        const temp = data['body'];
        let intervals = [];

        if (temp.CDROverTime?.length > 0) {
          intervals = temp.CDROverTime;
        } else if (temp.KeepAliveOverTime?.length > 0) {
          intervals = temp.KeepAliveOverTime;
        } else if (temp.MikrotikOverTime?.length > 0) {
          intervals = temp.MikrotikOverTime;
        }

        const graphObject: any = {
          month: this.tools.GetCurrentMonthName(),
          year: this.tools.GetCurrentYear(),
          status: [],
          weeks: [],
        };

        for (let i = 0; i < intervals.length; i++) {
          let isSet = false;
          if (temp.CDROverTime != null) {
            isSet = isSet || temp.CDROverTime[i].Online > 0;
          }

          if (temp.KeepAliveOverTime != null) {
            isSet = isSet || temp.KeepAliveOverTime[i].Online > 0;
          }

          if (temp.MikrotikOverTime != null) {
            isSet = isSet || temp.MikrotikOverTime[i].Online > 0;
          }

          graphObject['status'].push(isSet ? 1 : 0);
          graphObject['weeks'].push(intervals[i]['IntervalStart']);
        }

        this.deviceStatusOverTime = graphObject;
      }
    });
  }

  getDevicePresets() {
    if (!this.AccessObject?.IsMikrotikUser()) {
      return;
    }
    this.genericService.GET(this.endpoints.GET_PRESETS).subscribe((results) => {
      this.presets = results['body'];
    });
  }

  getRouterSnapshotDetails(id: number) {
    this.genericService.GET(this.endpoints.GET_MIKROTIK_SNAPSHOT_INFO(id)).subscribe((results) => {
      this.retryDeviceSnapshotDetailsAddition(results['body']);
    });
  }

  retryDeviceSnapshotDetailsAddition(data: any) {
    if (this.detailsObject && this.detailsObject.CdrDevice) {
      this.detailsObject.CdrDevice.SnapshotInfo = data;
      if (this.detailsObject.CdrDevice.SnapshotInfo?.Details?.IdentityName && this.obfuscateData) {
        this.detailsObject.CdrDevice.SnapshotInfo.Details.IdentityName = this.tools.Obfuscate(this.detailsObject.CdrDevice.SnapshotInfo.Details.IdentityName, 'Identity', 8);
      }
      return;
    }

    setTimeout(() => {
      this.retryDeviceSnapshotDetailsAddition(data);
    }, 100);
  }

  getDeviceBundleUsageData(id: number, sixMonthsObj?: any) {
    if (!this.AccessObject?.IsCDRUser() && !this.AccessObject?.IsSuperUser()) {
      return;
    }
    this.genericService
      .POST(this.endpoints.GET_DEVICE_USAGE_OVER_TIME, {
        GroupID: this.auth.GetGroupID(),
        Start: sixMonthsObj ? sixMonthsObj.Start : this.tools.FormatStartDate(this.tools.GetStartOfMonth(new Date()).toISOString()),
        End: sixMonthsObj ? sixMonthsObj.End : this.tools.FormatEndDate(this.tools.GetEndOfMonth().toISOString()),
        PerMonth: false,
        DeviceID: id,
      })
      .subscribe((data) => {
        if (data['body'] != null) {
          const intervals = data['body'];
          let c = this.DailyDataUsageGraphConfig;

          let graphObject: any = {
            month: sixMonthsObj ? this.tools.GetDateMonthName(this.tools.ParseAPIDate(sixMonthsObj.Start)) : this.tools.GetCurrentMonthName(),
            year: sixMonthsObj ? this.tools.GetDateYear(this.tools.ParseAPIDate(sixMonthsObj.Start)) : this.tools.GetCurrentYear(),
            dataUsed: [],
            totalData: [],
            projected: [],
            weeks: [],
            isCumulative: true,
          };

          let tempStart = sixMonthsObj && sixMonthsObj.Start ? new Date(sixMonthsObj.Start) : new Date();
          let tempEnd = sixMonthsObj && sixMonthsObj.Start ? this.tools.GetEndOfMonthFromDate(new Date(sixMonthsObj.Start)) : new Date();
          let title = 'Bundle used in MB (' + this.tools.GetStartOfMonth(tempStart).toLocaleDateString('sv-SE') + ' - ' + tempEnd.toLocaleDateString('sv-SE') + ')';

          for (let i = 0; i < intervals['UsageOverTime'].length; i++) {
            graphObject['dataUsed'].push(this.tools.ConvertDataFromBytes(intervals['UsageOverTime'][i]['TotalUsage'], 'MB'));
            graphObject['weeks'].push(this.tools.FormatSwedishDate(this.tools.ParseAPIDate(intervals['UsageOverTime'][i]['Start'])));
            graphObject['totalData'].push(this.tools.ConvertDataFromBytes(intervals['BundleOverTime'][i]['InBundleAmount'], 'MB'));
          }

          graphObject['dataUsed'] = this.tools.CalculateUsages(graphObject['dataUsed'], 2);

          if (sixMonthsObj) {
            graphObject['NewDate'] = this.tools.ParseAPIDate(sixMonthsObj.Start);
          }

          if (graphObject['dataUsed'].length >= 2) {
            const projectionData = this.tools.calculateProjectionData(graphObject);
            this.daysInMonth = projectionData.daysInMonth;
            graphObject = projectionData.graphObject;
          } else {
            this.daysInMonth = graphObject['dataUsed'].length;
          }

          if (graphObject.projected.length >= 2 && graphObject.projected[graphObject.projected.length - 1] > graphObject.totalData[graphObject['totalData'].length - 1]) {
            this.willExceedBundle = true;

            if (this.usageOverMonthsData != null) {
              const temp = this.usageOverMonthsData;
              this.usageOverMonthsData = null;
              temp[temp.length - 1]['WillExceedBundle'] = true;
              this.usageOverMonthsData = temp;
            }
          }

          const bundleAmount = graphObject['totalData'][graphObject['totalData'].length - 1];
          for (let i = graphObject['totalData'].length; i < this.daysInMonth; i++) {
            graphObject['totalData'].push(bundleAmount); // Fill rest of month with last InBundleAmount
          }

          let tempSeries = [
            {
              name: 'Projection (MB)',
              data: graphObject.projected,
              color: '#FFB347',
            },
            {
              name: 'Bundle (MB)',
              data: graphObject.totalData,
              color: '#990000',
            },
            {
              name: 'Data Used (MB)',
              data: graphObject.dataUsed,
              color: '#3FC944',
            },
          ];

          c.UnprocessedData = data;
          c.Data.GraphTitle = title;
          c.Data.SeriesData = tempSeries;
          c.Data.XAxisCategories = graphObject['weeks'] ? graphObject['weeks'] : [];
          c.IsReady = true;
          if (c.Callback != null) {
            c.Callback(c);
          }

          this.changeDetectorRef.detectChanges();
        }

        this.detailsCardWidth = this.calculateDetailsWidth();
      });
  }

  getDeviceUsageOvertimeMonths(deviceID, monthDiff) {
    if (!this.AccessObject?.IsCDRUser() && !this.AccessObject?.IsSuperUser()) {
      return;
    }
    const startDate = new Date();
    startDate.setMonth(startDate.getMonth() - monthDiff);
    startDate.setDate(1);
    const reqObj = {
      Start: this.tools.FormatStartDate(startDate.toISOString()),
      End: this.tools.FormatEndDate(this.tools.GetEndOfMonth().toISOString()),
      DeviceID: deviceID,
      GroupID: this.auth.GetGroupID(),
      PerMonth: true,
    };

    this.genericService.POST(this.endpoints.GET_DEVICE_USAGE_OVER_TIME, reqObj).subscribe((results: any) => {
      const data = results['body'];
      if (data != null) {
        let c = this.MonthlyDataUsageGraphConfig;
        let graphObject = {
          month: 'January',
          year: '2022',
          dataUsed: [],
          weeks: [],
          projected: [],
          totalData: [],
        };
        const data = results['body']['UsageOverTime'];
        const bundle = results['body']['BundleOverTime'];
        this.usageOverMonthsStorage = results['body']['UsageOverTime'];
        const temp: any = [];
        for (let i = 0; i < data.length; i++) {
          // Formatting for the six months data
          const tempDate = this.tools.ParseAPIDate(data[i]['Start']);
          temp.push({
            TotalUsage: this.tools.ConvertDataFromBytes(data[i]['TotalUsage'], 'MB').toFixed(2),
            Start: `${tempDate.getFullYear()}/${('0' + (tempDate.getMonth() + 1)).slice(-2)}`,
            ExceededUsage: data[i]['TotalUsage'] > bundle[i]['InBundleAmount'],
          });

          if (i == data.length - 1) {
            temp[temp.length - 1]['WillExceedBundle'] = this.willExceedBundle;
          }

          graphObject['dataUsed'].push(temp[i]['TotalUsage']);
          graphObject['weeks'].push(temp[i]['Start']);
        }

        let seriesData = [];
        seriesData.push({
          name: 'Data Used (MB)',
          data: temp.map((entry, i) => {
            return {
              x: entry.Start,
              y: entry.TotalUsage,
              fillColor: entry.ExceededUsage ? '#990000' : '#3FC944',
            };
          }),
        });

        if (c.Callback != null) {
          c.UnprocessedData = data;
          c.Callback(c);
        } else {
          c.UnprocessedData = data;
        }

        c.Data.SeriesData = seriesData;
        c.Data.XAxisCategories = graphObject['weeks'] ? graphObject['weeks'] : [];
        c.IsReady = true;
      }
    });
  }

  PageChanged(eve) {
    if (this.loading) {
      return;
    }
    this.calculateMapWidth(eve['ID']);

    switch (eve['ID']) {
      case 2:
        if (this.mapConfig) {
          this.mapConfig.Fullscreen = true;
        }
        break;
      case 11:
        this.getDailyRelayGraphData(this.DailyRelayGraphConfig);
        this.getMonthlyRelayGraphData(this.MonthlyRelayGraphConfig);
        break;
      default:
        if (this.deviceMap) {
          this.deviceMap.advancedLocation = false;
        }
        if (this.mapConfig) {
          this.mapConfig.Fullscreen = false;
        }
    }

    this.page = eve['ID'];
  }

  determineActiveSimNum(): string | null {
    if (this.isMikrotik) {
      if (this.detailsObject?.CdrDevice?.LastSnapshotEvent?.Uicc != null) {
        this.detailsObject.CdrDevice.LastSnapshotEvent.Uicc = this.detailsObject.CdrDevice.LastSnapshotEvent.Uicc.replace(/\D/g, '');
        return this.detailsObject.CdrDevice.LastSnapshotEvent.Uicc;
      }
    }

    if (this.isKA) {
      return this.detailsObject?.KaDevice?.AggregatedTowerPing?.scid;
    }

    if (this.isCDR) {
      return this.detailHeader?.CdrOnline && this.detailsObject?.CdrDevice?.SIMs?.length == 1 ? this.detailsObject?.CdrDevice?.SIMs[0].SimNum : null;
    }

    return null;
  }

  buildDetailHeaderObject() {
    this.detailHeader = new DetailDeviceHeader();
    if (this.detailsObject.CdrDevice != null) {
      this.detailHeader.IsCapped = this.detailsObject?.IsCapped;
      if (!this.detailsObject.CdrDevice['InBundleAmount']) {
        this.detailsObject.CdrDevice['InBundleAmount'] = 0;
      }
      this.detailHeader.SerialNumber = this.detailsObject.CdrDevice.SerialNumber;
      this.detailHeader.DeviceID = this.detailsObject.CdrDevice.ID;
      this.detailHeader.DeviceNum = this.detailsObject.CdrDevice.DeviceNum;
      this.detailHeader.DeviceType = this.detailsObject.CdrDevice.DeviceType;
      this.detailHeader.CdrLastUsage = this.detailsObject.CdrDevice.LastUsage
        ? this.tools.FormatSwedishDateTime(this.tools.ParseAPIDateWithTimezone(this.detailsObject.CdrDevice.LastUsage))
        : null;
      this.detailHeader.CdrOnline = this.detailsObject.CdrDevice?.ActivityStatus?.UsageStatus == true;
      this.detailHeader.MikrotikOnline = this.detailsObject.CdrDevice?.ActivityStatus?.MikrotikPingStatus == true;
      this.detailHeader.MikrotikLastPing = this.detailsObject.CdrDevice.LastPing
        ? this.tools.FormatSwedishDateTime(this.tools.ParseAPIDateWithTimezone(this.detailsObject.CdrDevice.LastPing))
        : null;
      this.detailHeader.Usage = this.tools.FormatUsage(this.detailsObject.CdrDevice.Usage == null ? 0 : this.detailsObject.CdrDevice.Usage);
      this.detailHeader.Bundle = this.tools.FormatBundleUsage(this.detailsObject.CdrDevice['InBundleAmount']);
      this.detailHeader.UsageLevel = this.tools.CalculateUsageLevel(this.detailsObject.CdrDevice['Usage'], this.detailsObject.CdrDevice['InBundleAmount']);
      this.detailHeader.Customer = this.detailsObject?.CdrDevice?.Customer?.Reference;
      this.detailHeader.SIMs = this.detailsObject?.CdrDevice.SIMs;
      this.detailHeader.IsMikrotik = this.detailsObject?.CdrDevice.IsMikrotik;
      this.detailHeader.IsCdr = this.detailsObject?.CdrDevice?.SIMs?.length > 0;
      this.detailHeader.CapSettings = this.detailsObject?.CdrDevice?.CapSettings;
      this.detailHeader.IMEI = this.detailsObject.CdrDevice.IMEI;
    }

    if (this.detailsObject?.KaDevice != null) {
      this.detailHeader.KAOnline = this.detailsObject.CdrDevice?.ActivityStatus?.KeepAliveStatus == true;
      this.detailHeader.KALastPing = this.detailsObject?.KaDevice
        ? this.tools.FormatSwedishDateTime(this.tools.ParseAPIDateWithTimezone(this.detailsObject.KaDevice.LastComms))
        : null;
      this.detailHeader.Merchant = this.detailsObject?.KaDevice?.Merchant?.Name;
      this.detailHeader.IsKa = true;
    }

    this.detailHeader.ActiveSim = this.determineActiveSimNum();
    if (JSON.stringify(this.kaTypes) === JSON.stringify(['tls'])) {
      this.detailHeader.TLSEnabled =
        (this.detailsObject.CdrDevice != null && this.detailsObject.CdrDevice.TLSEnabled == true) ||
        (this.detailsObject.KaDevice != null && this.detailsObject.KaDevice.TLSEnabled == true);
    } else if (this.kaTypes.includes('tls') && this.kaTypes.includes('location')) {
      this.detailHeader.TLSEnabled =
        (this.detailsObject.CdrDevice != null && this.detailsObject.CdrDevice.TLSEnabled == true) ||
        (this.detailsObject.KaDevice != null && this.detailsObject.KaDevice.TLSEnabled == true);
    } else if (JSON.stringify(this.kaTypes) === JSON.stringify(['location'])) {
      this.detailHeader.TLSEnabled = false;
    }
  }

  buildDeviceDetailsConfig() {
    const conf = {
      DeviceNumber: this.detailsObject.CdrDevice?.DeviceNum,
      DeviceType: this.detailsObject.CdrDevice?.DeviceType,
    } as MinDeviceDetails;

    if (this.detailsObject.CdrDevice != null) {
      conf.ID = this.detailsObject.CdrDevice.ID;
      conf.IsCDR = true;
      conf.kaID = this.detailsObject.CdrDevice?.KaID;
      conf.DeviceNumber = this.detailsObject.CdrDevice.DeviceNum;
      conf.DeviceType = this.detailsObject.CdrDevice.DeviceType;
      conf.IP = this.detailsObject.CdrDevice.LastIP;
      conf.InBundleAmount = this.detailsObject.CdrDevice.InBundleAmount;
      conf.Usage = this.detailsObject.CdrDevice.Usage;
      conf.KillswitchEnabled = this.detailsObject.CdrDevice.KillSwitchEnabled;
      conf.Manufacturer = this.detailsObject.CdrDevice.Manufacturer;
      conf.Cluster = this.detailsObject.CdrDevice.Cluster;
      conf.DeviceStatus = this.detailsObject.CdrDevice.DeviceStatus;
      conf.Reference = this.detailsObject.CdrDevice.Customer?.Reference;
      conf.IsMikrotik = this.detailsObject.CdrDevice.IsMikrotik;
      conf.TerminalID = this.detailsObject.CdrDevice.TerminalID;
      conf.MerchantName = this.detailsObject.CdrDevice.MerchantName;
      conf.SerialNumber = this.detailsObject.CdrDevice.SerialNumber;
      conf.IMEI = this.detailsObject.CdrDevice.IMEI;
    }

    if (this.detailsObject?.KaDevice != null) {
      conf.ID = this.detailsObject?.KaDevice.ID;
      conf.isKA = true;
      conf.TerminalID = this.detailsObject?.KaDevice.TerminalID;
      conf.TerminalSupplier = this.detailsObject?.KaDevice.TerminalSupplier;
      conf.TerminalType = this.detailsObject?.KaDevice.TerminalType;
      conf.AcquiringBank = this.detailsObject?.KaDevice?.AcquiringBank;
      conf.SequenceNumber = this.detailsObject?.KaDevice?.AggregatedTowerPing?.count;
      conf.TowerInfo = this.detailsObject?.KaDevice?.AggregatedTowerPing?.CellTower;
      conf.AvgCSQ = this.detailsObject?.KaDevice?.AggregatedTowerPing?.avg_csg;
      conf.MerchantName = this.detailsObject?.KaDevice?.Merchant?.name;
    }

    this.deviceDetailsConfig = conf;
  }

  handleDeviceDataDistribution() {
    if (this.mapConfig && this.detailsObject?.KaDevice != null) {
      this.mapConfig.TerminalID = this.detailsObject?.KaDevice.TerminalID;
    }
  }

  getDeviceDetails() {
    this.loading = true;

    this.requestParameters.ShowUsage = true;
    this.requestParameters.ShowPing = true;
    this.requestParameters.ShowSnapshot = true;
    this.requestParameters.ShowStatusChange = true;
    this.requestParameters.ShowSite = true;
    this.requestParameters.ShowAllocationInfo = true;
    this.requestParameters.ShowCluster = true;
    this.requestParameters.ShowProductClass = true;
    this.requestParameters.ShowActivityStatus = true;
    this.requestParameters.ShowScheduler = true;
    this.requestParameters.ShowMerchant = true;
    this.requestParameters.ShowAggregatedPing = true;
    this.requestParameters.ShowRingfenceLogs = true;
    this.requestParameters.ShowProxyServers = true;
    this.requestParameters.ShowSnapshotLocations = true;
    this.requestParameters.ShowUsageCapSettings = true;
    this.requestParameters.ShowTLS = true;
    this.requestParameters.ShowLatestTLSPingPacket = true;
    this.genericService.POST(this.endpoints.GET_DEVICE(), this.requestParameters).subscribe(
      (result: any) => {
        if (result['body'] != null) {
          this.detailsObject = result['body'];

          // Obfuscate the data returned
          if (this.detailsObject.CdrDevice?.Customer?.Aggregate?.Description && this.obfuscateData) {
            this.detailsObject.CdrDevice.Customer.Aggregate.Description = this.tools.Obfuscate(this.detailsObject.CdrDevice.Customer.Aggregate.Description, 'Aggregate', 8);
          }

          if (this.detailsObject.CdrDevice?.Customer?.TradingName && this.obfuscateData) {
            this.detailsObject.CdrDevice.Customer.TradingName = this.tools.Obfuscate(this.detailsObject.CdrDevice.Customer.TradingName, 'Name', 8);
          }

          if (this.detailsObject.CdrDevice?.Customer?.Reference && this.obfuscateData) {
            this.detailsObject.CdrDevice.Customer.Reference = this.tools.Obfuscate(this.detailsObject.CdrDevice.Customer.Reference, 'Reference', 8);
          }

          if (this.detailsObject.KaDevice?.AcquiringBank && this.obfuscateData) {
            this.detailsObject.KaDevice.AcquiringBank = this.tools.Obfuscate(this.detailsObject.KaDevice.AcquiringBank, 'Bank', 8);
          }

          if (this.detailsObject.KaDevice?.Merchant?.name && this.obfuscateData) {
            this.detailsObject.KaDevice.Merchant.name = this.tools.Obfuscate(this.detailsObject.KaDevice.Merchant.name, 'Merchant', 8);
          }

          this.isMikrotik = this.detailsObject?.CdrDevice?.IsMikrotik;
          this.buildDetailHeaderObject();
          this.buildDeviceDetailsConfig();
          this.handleDeviceDataDistribution();
          if (this.detailsObject?.CdrDevice?.SIMs?.length) {
            this.getDeviceBundleUsageData(this.requestParameters['CdrID']);

            let apnMep: Map<string, any> = new Map();
            for (let i = 0; i < this.detailsObject.CdrDevice.SIMs.length; i++) {
              this.simIDs.push(this.detailsObject.CdrDevice.SIMs[i].SimID);
              let mnoMepVal: Map<string, any> = new Map();
              this.detailsObject.CdrDevice.SIMs[i].APNInfo?.forEach((apn) => {
                let apnMepVal = apnMep.get(apn.APN);
                if (apnMepVal != null) {
                  if (i == 0) {
                    apnMep.set(apn.APN, {
                      ...apnMepVal,
                      Sim1Network: this.detailsObject.CdrDevice.SIMs[i].ServiceProvider,
                      Sim1IP: apn.IP,
                    });
                  } else {
                    apnMep.set(apn.APN, {
                      ...apnMepVal,
                      Sim2Network: this.detailsObject.CdrDevice.SIMs[i].ServiceProvider,
                      Sim2IP: apn.IP,
                    });
                  }
                } else {
                  apnMep.set(apn.APN, {
                    APN: apn.APN,
                    Sim1Network: i == 0 ? this.detailsObject.CdrDevice.SIMs[i].ServiceProvider : null,
                    Sim2Network: i == 1 ? this.detailsObject.CdrDevice.SIMs[i].ServiceProvider : null,
                    Sim1IP: i == 0 ? apn.IP : null,
                    Sim2IP: i == 1 ? apn.IP : null,
                  });
                }

                if (apn.IP != null && apn.IP.length > 0) {
                  mnoMepVal.set(apn.APN, {
                    Network: this.detailsObject.CdrDevice.SIMs[i].ServiceProvider,
                    APN: apn.APN,
                    IP: apn.IP,
                    Transactions: [],
                  });

                  if (!this.deviceIPs.includes(apn.IP)) {
                    this.deviceIPs.push(apn.IP);
                  }
                }
              });
              this.mnoMep.set(this.detailsObject.CdrDevice.SIMs[i].ServiceProvider, mnoMepVal);
            }

            this.deviceApnList = Array.from(apnMep.values());

            this.detailsObject?.CdrDevice?.SIMs?.forEach((sim) => {
              sim.APNInfo?.forEach((apn) => {
                if (apn.IP.length > 0) {
                  this.deviceIPs.push(apn.IP);
                }
              });
            });
          } else {
            this.detailsCardWidth = this.calculateDetailsWidth();
            this.calculateMapWidth();
          }

          if (this.isMikrotik && !this.isKA) {
            this.endpointsLoading++;
            this.getMikrotikLocationHistory();
          }
        }

        this.buildSidePane();
        this.getSimLocationHistory();

        this.loading = false;
        this.endpointsLoading--;
      },
      () => {
        this.loading = false;
        this.endpointsLoading--;
      },
    );
  }

  calculateDetailsWidth() {
    if ((this.isKA || this.isCDR) && !this.isMikrotik) {
      return '25%';
    }

    if (this.isMikrotik && !this.deviceBundleUsed) {
      return '50%';
    }

    if (this.isMikrotik && this.deviceBundleUsed) {
      return '25%';
    }

    return '100%';
  }

  calculateMapWidth(page?) {
    if (page != null && page == 2) {
      this.mapDivWidth = '100%';
    } else {
      if ((this.isKA || this.isCDR) && !this.isMikrotik) {
        this.mapDivWidth = '75%';
      }

      if (this.isMikrotik && !this.deviceBundleUsed) {
        this.mapDivWidth = '50%';
      }

      if (this.isMikrotik && this.deviceBundleUsed) {
        this.mapDivWidth = '75%';
      }
    }
  }

  nextChar(c) {
    return String.fromCharCode(c.charCodeAt(0) + 1);
  }

  advancedToggled(showingAdvanced: boolean) {
    if (showingAdvanced) {
      this.mapSize = 12;
      const tabItem = this.detailsNavOptions[0]['Links'].filter((obj) => {
        return obj.ID == 2;
      })[0];
      this.pageChangeVal = tabItem;
      this.PageChanged(tabItem);
    } else {
      this.mapSize = 6;
      const tabItem = this.detailsNavOptions[0]['Links'].filter((obj) => {
        return obj.ID == 1;
      })[0];
      this.pageChangeVal = tabItem;
      this.PageChanged(tabItem);
    }
  }

  getKADeviceLocationHistory() {
    if (!this.AccessObject?.IsKeepAliveUser() && !this.AccessObject?.IsSuperUser()) {
      return;
    }
    this.LocationHistoryBody.ID = this.requestParameters.KaID;
    this.deviceLocationsLoading = true;
    this.deviceLocations = null;
    this.genericService.POST(this.endpoints.GET_DEVICE_LOCATION_HISTORY(), this.LocationHistoryBody).pipe(finalize(() => {
      this.deviceLocationsLoading = false;
    })).subscribe((resp) => {
      this.deviceLocations = resp['body']['Locations'];
      if (!this.mapConfig) {
        this.mapConfig = {
          Loading: false,
          Fullscreen: false,
          TerminalID: this.detailsObject?.KaDevice?.TerminalID,
        };
      }
      this.endpointsLoading--;
    });
  }

  getMikrotikLocationHistory() {
    if (!this.AccessObject?.IsMikrotikUser()) {
      return;
    }
    const deviceLocations = this.detailsObject.CdrDevice.Locations;

    const mikrotikLocations: any = [];
    if (deviceLocations != null && deviceLocations.length > 0) {
      for (let i = 0; i < deviceLocations.length; i++) {
        if (deviceLocations[i].Tower != null) {
          mikrotikLocations.push({
            ID: deviceLocations[i].Tower.ID,
            Lat: deviceLocations[i].Tower.Lat,
            Long: deviceLocations[i].Tower.Long,
            Timestamp: new Date(deviceLocations[i].Timestamp).valueOf() / 1000, // Gets epoch time, devide by 1000 to convert from ms to s
            Tower: deviceLocations[i].Tower,
          });
        }
      }
    }

    setTimeout(() => {
      this.deviceLocations = mikrotikLocations;
      if (!this.mapConfig) {
        this.mapConfig = {
          Loading: false,
          Fullscreen: false,
          TerminalID: this.detailsObject?.KaDevice?.TerminalID,
        };
      }
      this.endpointsLoading--;
    });
  }

  async openLocationRadiusModal() {
    if (this.requestParameters['KaID'] == null) {
      return;
    }

    let currentLocation = {};
    let data = null;
    let towerid = -1;
    if (this.detailsObject && this.detailsObject.KaDevice && this.detailsObject.KaDevice?.RingfenceLog) {
      towerid = this.detailsObject.KaDevice?.RingfenceLog.Tower?.ID;
      if (this.detailsObject.KaDevice?.LatestRingfenceAlert != null) {
        currentLocation = {
          lat: this.detailsObject.KaDevice?.LatestRingfenceAlert.Data.Point.Lat,
          lng: this.detailsObject.KaDevice?.LatestRingfenceAlert.Data.Point.Lng,
        };
        data = this.detailsObject.KaDevice?.LatestRingfenceAlert.Data;
      } else {
        currentLocation = {
          lat: this.detailsObject.KaDevice?.RingfenceLog.Center?.lat,
          lng: this.detailsObject.KaDevice?.RingfenceLog.Center?.lng,
        };
      }
    }

    const dialogRef = this.dialog.open(LocationRadiusModalComponent, {
      data: {
        celltower: towerid,
        viewOnly: false,
        deviceIds: [this.requestParameters['KaID']],
        device: {
          imei: this.detailsObject.KaDevice.IMEI,
          terminalid: this.detailsObject.KaDevice.TerminalID,
          location: currentLocation,
          data: data,
        },
        currentRingFenceValue: this.detailsObject.KaDevice.RingfenceLog.Radius / 1000,
      },
      hasBackdrop: false,
      // panelClass: 'location-radius-container' idk if this class will even work with a mat dialog
    });

    let dialogSub = dialogRef.afterClosed().subscribe({
      next: (dataReturned) => {
        if (dataReturned != null && dataReturned.data != null) {
          this.detailsObject.KaDevice.RingfenceLog.Radius = dataReturned.data['Radius'];
          this.getRingFenceData(this.requestParameters['KaID']);
          setTimeout(() => { });
        }
        dialogSub.unsubscribe();
      },
    });
  }

  getLatestRingfenceAlert(id: number) {
    if (!this.AccessObject?.IsKeepAliveUser() || !this.AccessObject?.IsSuperUser()) {
      return;
    }
    this.genericService.GET(this.endpoints.GET_LATEST_DEVICE_RINGFENCE_ALERT(id)).subscribe(
      (results) => {
        if (this.detailsObject && this.detailsObject.KaDevice) {
          this.detailsObject.KaDevice.LatestRingfenceAlert = results['body'];
        }
      },
      (err) => {
        console.log(err);
      },
    );
  }

  presetClicked(clickedPreset: DevicePreset) {
    this.presetToPreview = null;
    this.presetResult = null;
    this.selectedPreset = clickedPreset;
  }

  cancelPresetClick() {
    for (let i = 0; i < this.selectedPreset?.Options?.length!; i++) {
      this.selectedPreset.Options[i]['Value'] = null;
    }

    this.selectedPreset = { ID: 0, Name: '', Script: '', Options: [] };
    this.presetToPreview = null;
  }

  previewPreset() {
    if (!this.selectedPreset) {
      return;
    }

    this.presetLoading = true;
    const requestBody = this.parsePresetRequestObject();

    this.genericService.POST(this.endpoints.PREVIEW_PRESET(this.selectedPreset.ID), requestBody).subscribe((results) => {
      if (results['body'] && results['body'].Message) {
        this.presetToPreview = results['body'].Message;
        this.presetLoading = false;
      }
    });
  }

  parsePresetRequestObject(): Object {
    const optionsBody = {};

    for (let i = 0; i < this.selectedPreset?.Options?.length!; i++) {
      optionsBody[this.selectedPreset?.Options[i].Name!] = this.selectedPreset?.Options[i]['Value'];
    }

    return {
      DeviceID: this.requestParameters.CdrID,
      PresetID: this.selectedPreset?.ID,
      Parameters: optionsBody,
    };
  }

  executePreset() {
    if (!this.selectedPreset || !this.AccessObject?.IsKeepAliveAdmin()) {
      return;
    }

    this.presetLoading = true;
    const requestBody = this.parsePresetRequestObject();

    this.genericService.POST(this.endpoints.EXECUTE_PRESET(this.selectedPreset.ID), requestBody).subscribe((results) => {
      this.presetResult = results['body']?.Message ? (results['body'].Message as string).replace(/(?:\r\n|\r|\n)/g, '<br>') : 'No response retrieved from the router';
      this.toastService.info('Please view the content div for the result', 'Command executed.', { timeOut: 8000 });
      this.presetLoading = false;
    });
  }

  locationSearched(requestParams: GetDeviceLocationRequest) {
    // this.hopsSearch = "";
    // this.hopsOffset = 0;

    this.LocationHistoryBody = requestParams;
    if (this.isMikrotik) {
      this.LocationHistoryBody.DeviceIds = [this.requestParameters.CdrID];
      // this.LocationHistoryBody.Search = this.LocationHistoryBody.Search.length > 0 ? this.LocationHistoryBody.Search : null;
      this.LocationHistoryBody.Operator = this.LocationHistoryBody.Operator?.length! > 0 ? this.LocationHistoryBody.Operator : null;

      const obj = {
        DeviceIds: this.LocationHistoryBody.DeviceIds,
        StartTime: this.LocationHistoryBody != null ? this.LocationHistoryBody.StartTime : 0,
        EndTime: this.LocationHistoryBody != null ? this.LocationHistoryBody.EndTime : 0,
        LAC: this.LocationHistoryBody != null ? this.LocationHistoryBody.LAC : null,
        CellID: this.LocationHistoryBody != null ? this.LocationHistoryBody.CellID : null,
        Operator: this.LocationHistoryBody != null ? this.LocationHistoryBody.Operator : null,
        Count: this.LocationHistoryBody != null ? this.LocationHistoryBody.Count : 10,
        GroupID: this.auth.GetGroupID(),
        Bounds: {
          SW: {
            Lat: -36.78053281978333,
            Long: 13.479175468749984,
          },
          NE: {
            Lat: -21.868960980132858,
            Long: 35.144214531249986,
          },
        },
        IgnoreBounds: false,
      };

      this.genericService
        .POST(this.endpoints.GET_ADVANCED_MIKROTIK(this.auth.GetGroupID(), this.LocationHistoryBody.Search?.length! > 0 ? this.LocationHistoryBody.Search! : '') + '&opn=true', obj)
        .subscribe((results) => {
          const body = results['body'];
          const mikrotikLocations: any = [];
          if (body != null) {
            const device = body[0]; // First value in array is used because there is only one device in this instance
            if (device.Locations != null) {
              for (let i = 0; i < device.Locations.length; i++) {
                if (device.Locations[i].Tower != null) {
                  mikrotikLocations.push({
                    ID: device.Locations[i].Tower.ID,
                    Lat: device.Locations[i].Tower.Lat,
                    Long: device.Locations[i].Tower.Long,
                    Timestamp: new Date(device.Locations[i].Timestamp).valueOf() / 1000, // Gets epoch time, divide by 1000 to convert from ms to s
                    Tower: device.Locations[i].Tower,
                  });
                }
              }
            }
          }

          setTimeout(() => {
            this.deviceLocations = mikrotikLocations;
            if (!this.mapConfig) {
              this.mapConfig = {
                Loading: false,
                Fullscreen: false,
                TerminalID: this.detailsObject?.KaDevice?.TerminalID,
              };
            }
            // this.endpointsLoading--;
          });
        });
    } else {
      this.getKADeviceLocationHistory();
    }
  }

  lastSixMonthsPointSelected(index: number) {
    const tempDate = this.tools.ParseAPIDate(this.usageOverMonthsStorage[index]['Start']);
    const obj = {
      Start: this.tools.FormatStartDate(this.tools.GetStartOfMonth(tempDate).toISOString()),
      End: this.tools.FormatEndDate(this.tools.GetEndOfMonthFromDate(tempDate).toISOString()),
    };

    this.deviceBundleUsed = null;
    this.dateMonthString = formatDate(tempDate, '(yyyy-MM)', 'en');
    this.getDeviceBundleUsageData(this.requestParameters['CdrID'], obj);
    this.getAPNDeviceUsages(this.requestParameters['CdrID'], obj.Start, obj.End);
  }

  async unblockDevice() {
    const dialogRef = this.dialog.open(ConfirmReasonModalComponent, {
      data: {
        message: `Please provide a reason to unblock this device`,
        showToggle: true,
        toggleLabels: ['Unblock fully', 'Unblock device for x MB'],
        isToggleInput: true,
        toggleText: `
					<div>
						Current Usage: ${this.tools.FormatUsage(this.detailsObject?.CdrDevice?.Usage)}
						<br />
						Current Limit: ${this.tools.FormatUsage(this.detailsObject?.CdrDevice?.CapSettings?.CapValue)}
						<br />
						Please insert new limit (in MB):
					</div>
				`,
      },
      hasBackdrop: false,
    });
    let dialogSub = dialogRef.afterClosed().subscribe({
      next: (res) => {
        if (res?.confirmed === true) {
          if (res.toggleInputValue != null && Number(res.toggleInputValue) * 1_000_000 < this.detailsObject?.CdrDevice?.Usage) {
            this.toastService.error('New limit must be higher than current usage', '', { timeOut: 2000 });
          } else {
            this.genericService
              .POST(this.endpoints.UNBLOCK_CAPPED_DEVICE(this.detailsObject?.CdrDevice?.ID), {
                Reason: res.reason,
                NewCap: res.toggleInputValue ? Number(res.data.toggleInputValue) * 1_000_000 : null,
              })
              .subscribe((res) => {
                this.toastService.success('Unblocked device. This may take a moment to take effect.', '', { timeOut: 2000 });
              });
          }
        }
        dialogSub.unsubscribe();
      },
    });
  }

  getDailyRelayGraphData(c: GraphChange, sixMonthsObj?: any, selectedRelayIP?: string | null) {
    this.relayDailyData = null;
    c.IsReady = false;

    let reqObj = {
      StartDate: sixMonthsObj ? sixMonthsObj.StartDate : this.tools.FormatStartDate(this.tools.GetStartOfMonth(new Date()).toISOString()),
      EndDate: sixMonthsObj ? sixMonthsObj.EndDate : this.tools.FormatEndDate(this.tools.GetEndOfMonth().toISOString()),
      TimeUnit: 4,
      TimeInterval: 1,
      IPs: selectedRelayIP != null ? [selectedRelayIP] : this.deviceIPs,
    };
    this.genericService.POST(this.endpoints.GET_SERVER_STATS, reqObj).subscribe(
      (res: any) => {
        this.relayDailyData = res.body;
        c.UnprocessedData = res.body;
        c.IsReady = true;
        if (c.Callback != null) {
          c.Callback(c);
        }
      },
      (error: any) => {
        console.log(error);
      },
    );
  }

  dailyRelayDataFormatter(c: GraphChange) {
    let graphObject: any = {
      month: c.GraphDashboard.relaySixMonthObj
        ? c.GraphDashboard.tools.GetDateMonthName(c.GraphDashboard.tools.ParseAPIDate(c.GraphDashboard.relaySixMonthObj.StartDate))
        : c.GraphDashboard.tools.GetCurrentMonthName(),
      year: c.GraphDashboard.relaySixMonthObj
        ? c.GraphDashboard.tools.GetDateYear(c.GraphDashboard.tools.ParseAPIDate(c.GraphDashboard.relaySixMonthObj.StartDate))
        : c.GraphDashboard.tools.GetCurrentYear(),
      success: [],
      null: [],
      days: [],
    };

    let tempEnd = c.GraphDashboard.relaySixMonthObj ? new Date(c.EndDate) : new Date();
    let title = 'Transactions (' + c.GraphDashboard.tools.GetStartOfMonth(new Date(c.StartDate)).toLocaleDateString('sv-SE') + ' - ' + tempEnd.toLocaleDateString('sv-SE') + ')';

    let transactionsMep: Map<string, any> = new Map();
    for (let i = 0; i < c.UnprocessedData.length; i++) {
      for (let o = 0; o < c.UnprocessedData[i].S.length; o++) {
        let transactionStat = c.UnprocessedData[i].S[o];
        let transactionMepElem = transactionsMep.get(transactionStat.T.split('T')[0]);
        if (transactionMepElem != null) {
          transactionsMep.set(transactionStat.T.split('T')[0], {
            Success: transactionMepElem.Success + transactionStat.S,
            Null: transactionMepElem.Null + transactionStat.N,
          });
        } else {
          transactionsMep.set(transactionStat.T.split('T')[0], {
            Success: transactionStat.S,
            Null: transactionStat.N,
          });
          graphObject['days'].push(transactionStat.T.split('T')[0]);
        }
      }
    }

    let transactionsArray = Array.from(transactionsMep.values());
    transactionsArray.forEach((el) => {
      graphObject.success.push(el.Success);
      graphObject.null.push(el.Null);
    });

    if (c.GraphDashboard.relaySixMonthObj) {
      graphObject['NewDate'] = this.tools.ParseAPIDate(c.GraphDashboard.relaySixMonthObj.StartDate);
    }

    let tempSeries = [
      {
        name: 'Success',
        data: graphObject.success,
        color: '#FFB347',
      },
      {
        name: 'Null',
        data: graphObject.null,
        color: '#990000',
      },
    ];

    c.Data.GraphTitle = title;
    c.Data.SeriesData = tempSeries;
    c.Data.XAxisCategories = graphObject['days'] ? graphObject['days'] : [];
  }

  getMonthlyRelayGraphData(c: GraphChange, selectedRelayIP?: string | null) {
    this.relayMonthlyBarData = null;

    let startDate = new Date();
    startDate.setMonth(startDate.getMonth() - this.monthDiff);
    startDate.setDate(1);
    let reqObj = {
      StartDate: startDate.toISOString(),
      EndDate: this.tools.GetEndOfMonth().toISOString(),
      IPs: selectedRelayIP != null ? [selectedRelayIP] : this.deviceIPs,
    };

    this.genericService.POST(this.endpoints.GET_TRANSACTION_DASHBOARD_MONTHLY, reqObj).subscribe((results: any) => {
      this.relayMonthlyBarData = results.body;
      c.UnprocessedData = results.body;
      c.IsReady = true;
      if (c.Callback != null) {
        c.Callback(c);
      }
    });
  }

  monthlyRelayDataFormatter(c: GraphChange) {
    let graphObject: any = {
      month: 'January',
      year: '2022',
      success: [],
      null: [],
      months: [],
    };

    let temp: any = [];
    for (let i = 0; i < c.UnprocessedData.length; i++) {
      // Formatting for the six months data
      let tempDate = c.GraphDashboard.tools.ParseAPIDate(c.UnprocessedData[i]['Month']);
      temp.push({
        Success: c.UnprocessedData[i]['Dashboard'].TotalSuccessful,
        Null: c.UnprocessedData[i]['Dashboard'].TotalNull,
        Start: `${('0' + (tempDate.getMonth() + 1)).slice(-2)}/${tempDate.getFullYear()}`, // Formatting date to show only month and year, also 0 if month < 10
      });

      graphObject.success.push(c.UnprocessedData[i]['Dashboard'].TotalSuccessful);
      graphObject.null.push(c.UnprocessedData[i]['Dashboard'].TotalNull);

      graphObject.months.push(c.GraphDashboard.tools.FormatDateFromDate(c.GraphDashboard.tools.ParseAPIDate(c.GraphDashboard.relayMonthlyBarData[i]['Month'])));
    }

    c.GraphDashboard.relayMonthlyData = temp;
    let seriesData: any = [];
    seriesData.push(
      {
        name: 'Success',
        data: graphObject.success,
      },
      {
        name: 'Null',
        data: graphObject.null,
      },
    );

    c.Data.SeriesData = seriesData;
    c.Data.XAxisCategories = graphObject.months ?? [];
  }

  handleRelayGraphSelection(index, dailyRelayGraph) {
    let tempDate = this.tools.ParseAPIDate(this.relayMonthlyBarData[index]['Month']);
    this.DailyRelayGraphConfig.StartDate, (dailyRelayGraph.StartDate = this.tools.GetStartOfMonth(tempDate));
    this.DailyRelayGraphConfig.EndDate, (dailyRelayGraph.EndDate = this.tools.GetEndOfMonthFromDate(tempDate));
    let dateObj = {
      StartDate: this.tools.FormatStartDate(this.tools.GetStartOfMonth(tempDate).toISOString()),
      EndDate: this.tools.FormatEndDate(this.tools.GetEndOfMonthFromDate(tempDate).toISOString()),
    };

    this.relaySixMonthObj = dateObj;
    this.getDailyRelayGraphData(dailyRelayGraph, dateObj, this.selectedRelayIP);
  }

  mnoSelected(mno: string, dailyRelayGraph?, monthlyRelayGraph?) {
    this.selectedRelayMNO = mno;
    this.mnoAPNs = [];
    if (mno != 'All') {
      for (let [_, value] of this.mnoMep.get(mno)!) {
        this.mnoAPNs.push(value);
      }
    } else {
      this.selectedRelayIP = null;
      this.getDailyRelayGraphData(dailyRelayGraph, this.relaySixMonthObj);
      this.getMonthlyRelayGraphData(monthlyRelayGraph);
    }
  }

  mnoAPNSelected(apn: string, dailyRelayGraph, monthlyRelayGraph) {
    this.selectedRelayIP = this.mnoMep.get(this.selectedRelayMNO)?.get(apn).IP;
    this.getDailyRelayGraphData(dailyRelayGraph, this.relaySixMonthObj, this.selectedRelayIP);
    this.getMonthlyRelayGraphData(monthlyRelayGraph, this.selectedRelayIP);
  }

  getPagedDevices(pageIndex: number, simDataObject: { page: number; totalLength: number; simNum: string; data: DeviceLocationTableData[] }) {
    console.log(pageIndex);
    this.simLocationsLoading = true;
    let newObj: { page: number; totalLength: number; simNum: string; data: DeviceLocationTableData[] } = {
      page: pageIndex,
      totalLength: simDataObject.totalLength,
      simNum: simDataObject.simNum,
      data: [],
    };
    newObj.page = pageIndex;
    newObj.totalLength = simDataObject.totalLength;
    newObj.simNum = simDataObject.simNum;
    this.deviceLocationsTableData.forEach((simLocationData, index) => {
      if (simLocationData[0].SimNum == newObj.simNum) {
        newObj.data = simLocationData.slice((pageIndex - 1) * this.cdrTableCount, pageIndex * this.cdrTableCount);
      }
    });

    setTimeout(() => {
      this.paginatedLocationsTableData.forEach((simLocationData, index) => {
        if (simLocationData.simNum == newObj.simNum) {
          simLocationData.page = newObj.page;
          simLocationData.data = newObj.data;
          simLocationData.totalLength = newObj.totalLength;
        }
      });
      this.simLocationsLoading = false;
    });
  }

  updateFocussedTower(selectedSim: BaseMapLocation) {
    console.log('Focussing tower: ', selectedSim);

    this.selectedSim = selectedSim;

    // scroll the screen so that the class=map-container is in view
    let element = document.querySelector('.map-container');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  }

  getSimLocationHistory() {
    this.deviceLocationsTableData = [];
    this.simLocations = null;
    this.invalidSimLocationCount = 0;
    this.simLocationsLoading = true;
    this.paginatedLocationsTableData = [];
    if (this.isValid()) {
      this.genericService
        .POST(this.endpoints.GET_SIMS_DEVICES('', this.auth.GetGroupID()), {
          SimIDs: this.simIDs,
          Start: this.startDateTime,
          End: this.endDateTime,
          MaxHops: this.firstLoad ? 10 : null,
          Bounds: this.deviceMapBounds,
          IgnoreBounds: true,
        })
        .subscribe((res) => {
          this.simLocations = [];
          if (res['body'] == null || res['body']['Sims'] == null) {
            return;
          }
          let simLocationsMap: Map<string, null> = new Map();
          res['body']['Sims'].forEach((sim) => {
            let simLocationData: DeviceLocationTableData[] = [];
            for (let i = 0; i < sim.Locations.length; i++) {
              let location = sim.Locations[i];

              if ((location.Lat == 0 && location.Long == 0) || location.Lat == null || location.Long == null) {
                this.invalidSimLocationCount++;
                continue;
              }
              simLocationData.push({
                SimNum: sim.SimNum,
                SimCell: sim.SimCell,
                Timestamp: this.tools.FormatDateTimeFromDateSwedish(this.tools.ParseAPIDateWithTimezone(location.Timestamp)),
                TimeFrom: this.tools.FormatDateTimeFromDateSwedish(this.tools.ParseAPIDateWithTimezone(location.TimeFrom)),
                TimeTo: this.tools.FormatDateTimeFromDateSwedish(this.tools.ParseAPIDateWithTimezone(location.TimeTo)),
                LAC: location.LAC,
                CellID: location.CellID,
                MCC: location.MCC,
                MNC: location.MNC,
                Lat: location.Lat,
                Long: location.Long,
                Provider: this.sharedTools.GetNetworkNameByMNC(location.MNC),
              });

              if (simLocationsMap.has(`${location.Lat} ${location.Long}`)) {
                continue;
              } else {
                simLocationsMap.set(`${location.Lat} ${location.Long}`, null);
              }

              // Unshift so that the latest timestamps are last in the array, because of how markers are drawn in Google Maps
              this.simLocations.unshift({
                latitude: location.Lat,
                longitude: location.Long,
                infoWindowContent: `
              <style>
                .gm-style-iw, .gm-style-iw-d{ height: fit-content !important; max-height: 250px !important; }
                .gm-ui-hover-effect>span { background-color: light-dark(#000, #000); }
              </style>
              <h4>${sim.SimNum}</h4>
              <h5>${sim.SimCell}</h5>
              <span>Timestamp: ${this.tools.FormatDateTimeFromDateSwedish(new Date(location.Timestamp))}</span><br />
              <span>Time From: ${this.tools.FormatDateTimeFromDateSwedish(new Date(location.TimeFrom))}</span><br />
              <span>Time To: ${this.tools.FormatDateTimeFromDateSwedish(new Date(location.TimeTo))}</span><br />
              <span>LAC: ${location.LAC}</span><br />
              <span>Cell ID: ${location.CellID}</span><br />
              <span>MCC: ${location.MCC}</span><br />
              <span>MNC: ${location.MNC}</span><br />
              <span>Provider: ${this.sharedTools.GetNetworkNameByMNC(location.MNC)}</span></span>
            `,
                customIcon: this.sharedTools.GetBasicTowerMarkerInfo(location.MNC, i == 0 ? 'c' : i == 1 ? 'p' : null),
              });

              this.simLocations[0].customIcon.icon = 'assets/map-markers/' + this.simLocations[0].customIcon.icon;
            }
            if (simLocationData.length > 0) {
              this.deviceLocationsTableData.push(simLocationData);
            }
          });

          //Populate the paginated table data
          this.deviceLocationsTableData.forEach((simLocationData, index) => {
            this.paginatedLocationsTableData.push({
              page: 1,
              simNum: simLocationData[0].SimNum,
              totalLength: simLocationData.length,
              data: simLocationData.slice(0, this.cdrTableCount),
            });
          });
          // this.paginatedLocationsTableData = this.deviceLocationsTableData.slice(0, this.currentCDRPage * this.cdrTableCount);

          this.deviceSimTableStyle = `repeat(${this.deviceLocationsTableData.length}, 1fr)`;
          this.simLocationsLoading = false;
        });
    }
  }
}
